import { useAuth0 } from '@auth0/auth0-react'
import { Box, Typography, Button, Avatar } from '@mui/material'
import BlockIcon from '@mui/icons-material/Block'
import LogoutIcon from '@mui/icons-material/Logout'

const AccessDenied = (): JSX.Element => {
  const { logout, user } = useAuth0()

  const handleSignOut = () => {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #F0F4F8 0%, #E0F7FA 50%, #F0F4F8 100%)',
        px: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2.5,
          p: { xs: 4, sm: 6 },
          borderRadius: 4,
          bgcolor: 'white',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(211, 47, 47, 0.12)',
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Avatar
          sx={{
            width: 72,
            height: 72,
            background: 'linear-gradient(135deg, #EF5350 0%, #D32F2F 100%)',
            boxShadow: '0 4px 16px rgba(211, 47, 47, 0.3)',
          }}
        >
          <BlockIcon sx={{ fontSize: 36, color: 'white' }} />
        </Avatar>

        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800, color: '#263238', mb: 0.5 }}>
            Access not available
          </Typography>
          <Typography variant="body2" sx={{ color: '#78909C', lineHeight: 1.6 }}>
            The Scrubstr admin portal is for invited team members only.
            {user?.email ? (
              <>
                {' '}
                Signed in as <strong>{user.email}</strong>.
              </>
            ) : null}
            Contact your administrator if you believe this is an error.
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<LogoutIcon />}
          onClick={handleSignOut}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 2,
            bgcolor: '#007C91',
            boxShadow: '0 2px 8px rgba(0, 124, 145, 0.3)',
            '&:hover': { bgcolor: '#006B7D' },
            mt: 1,
          }}
        >
          Sign out
        </Button>
      </Box>
    </Box>
  )
}

export default AccessDenied
